import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@xxtract/ui';
import type { MappingProfileVersion } from '../intake.api';

export interface MappingProfileVersionListProps {
  versions: MappingProfileVersion[];
}

/** h5-7 FR35 Beheer: version history, newest (= active) first — a reset shows up as an empty-mappings row with its audit note. */
export function MappingProfileVersionList({ versions }: MappingProfileVersionListProps) {
  const { t } = useTranslation();

  if (versions.length === 0) {
    return (
      <p role="status" data-testid="mapping-profile-versions-empty" className="text-sm text-[var(--foreground-muted)]">
        {t('admin.mappingProfiles.noProfile')}
      </p>
    );
  }

  return (
    <Table data-testid="mapping-profile-version-list">
      <TableHeader>
        <TableRow>
          <TableHead>{t('admin.mappingProfiles.table.version')}</TableHead>
          <TableHead>{t('admin.mappingProfiles.table.mappingCount')}</TableHead>
          <TableHead>{t('admin.mappingProfiles.table.createdAt')}</TableHead>
          <TableHead>{t('admin.mappingProfiles.table.note')}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {versions.map((version, index) => (
          <TableRow key={version.id} data-testid={`mapping-profile-version-row-${version.version}`}>
            <TableCell>
              {version.version}
              {index === 0 ? (
                <span className="ml-2 rounded-[var(--radius-control)] bg-[var(--success-light)] px-2 py-0.5 text-xs text-[var(--success-dark)]">
                  {t('admin.mappingProfiles.table.active')}
                </span>
              ) : null}
            </TableCell>
            <TableCell>{version.mappings.length}</TableCell>
            <TableCell>{new Date(version.createdAt).toLocaleDateString()}</TableCell>
            <TableCell>{version.resetNote ?? t('admin.mappingProfiles.table.noNote')}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
